import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'setting-edit-modal-component',
    templateUrl: './edit-modal.component.html',
    styleUrls: ['./edit-modal.component.scss'],
})
export class SettingEditModalComponent implements OnChanges {
    @Input() component: string;
    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() form: FormGroup;
    @Input() formSubmitted: boolean;
    @Input() languages: Object[];
    @Input() categories: Object[];
    @Input() itemLanguage: string;
    @Input() authService: AuthService;
    @Input() helpRawData = '';
    @Input() domains: Object[];
    @Input() diagnoses: Object[];

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    @ViewChild('formDirective') private formDirective: NgForm;

    isImageSaved = false;

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['params'] && this.formDirective) {
            this.formDirective.resetForm();
        }
    }

    onInputFocused(event, formGroup: any, isBottomField?: boolean) {
        let uagent = navigator.userAgent.toLowerCase();
        if (!(!/chrome/.test(uagent) && /safari/.test(uagent))) {
            // wait for the virtual keyboard to scroll up so that the scroll height can be updated correctly
            setTimeout(() => {
                if (isBottomField) {
                    document.body.scroll({
                        top: document.body.scrollHeight,
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    document.body.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }

                let modalElement = document.getElementsByClassName('modal')[0] as HTMLElement;
                modalElement.scroll({
                    top: formGroup.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 2000);
        }
    }

    thumbnailUploaded($event) {
        this.isImageSaved = true;
        this.form.controls['logo_url'].setValue($event.serverResponse.response.body.fullPath);
        this.form.controls['logo'].setValue($event.serverResponse.response.body.logo);
    }
}
